import { LandingContent } from "./types";
import {
  GiDodge,
  GiScissors,
  GiStopwatch,
  GiChatBubble,
  GiNotebook,
} from "react-icons/gi";
import { FaPaintBrush } from "react-icons/fa";
import { FaQuestion } from "react-icons/fa";
import dogGroomingImage from "../../assets/images/dog.jpg";

export const dogGroomingContent: LandingContent = {
  seo: {
    title: "Kutyakozmetikusok online időpontfoglaló rendszere | Wobble",
    description:
      "Egyszerű és gyors online időpontfoglaló rendszer kutyakozmetikusoknak és kisállat szépségápolóknak. Próbáld ki a Wobble-t ingyen!",
    ogTitle: "Wobble - Kutyakozmetikusok időpontfoglaló rendszere",
    ogDescription:
      "Kezeld egyszerűen a kutyakozmetikus foglalásokat, vendégeket és kommunikációt egyetlen felületen – spórolj időt és növeld a bevételeidet!",
    keywords: "kutyakozmetika, kutyakozmetikus, időpontfoglalás, online foglalás, wobble",
    image: "../assets/mockup_dog_grooming.png",
  },
  header: {
    heading: "Időpontfoglaló rendszer kutyakozmetikusoknak",
    subheading:
      "Kezeld egyszerűen a kutyakozmetikai szolgáltatásokat és vendégeket – foglalj könnyedén időpontokat kisállatoknak.",
    highlightText: "Wobble időpontfoglaló kutyakozmetikusoknak",
  },
  problems: {
    title: "Ismerős problémák?",
    features: [
      { icon: FaPaintBrush, text: "Papíralapú vagy bonyolult foglalási rendszerek, amik időrablók." },
      { icon: GiChatBubble, text: "Nehéz kommunikálni a gazdikkal lemondás vagy időpontváltozás esetén." },
      { icon: GiStopwatch, text: "Az időpontok egyeztetése sok időt vesz el a munkából." },
      { icon: FaQuestion, text: "Ismétlődő kérdések és foglalási egyeztetések megnehezítik a napokat." },
      { icon: GiScissors, text: "Sokféle szolgáltatás és különböző állatfajták kezelése bonyolult lehet." },
    ],
    summaryText:
      "A Wobble online időpontfoglalóval automatizálhatod a foglalásokat, így több időd jut a kutyákra és gazdáikra.",
    cta: {
      href: "https://app.wobble.hu/signup_page",
      label: "Kipróbálom ingyen",
    },
    imageSrc: dogGroomingImage,
    imageAlt: "Kutyakozmetikus időpontfoglalás",
  },
  whyDigitalize: {
    title: "Miért érdemes digitalizálni?",
    features: [
      { icon: GiDodge, text: "A gazdik egyre inkább online keresik a kutyakozmetikai szolgáltatásokat." },
      { icon: GiStopwatch, text: "Online foglalással a gazdik bármikor gyorsan foglalhatnak időpontot." },
      { icon: GiChatBubble, text: "Automatikus értesítések csökkentik a telefonos egyeztetések számát." },
      { icon: GiNotebook, text: "Rugalmas szolgáltatások és időpontok testreszabása." },
      { icon: GiScissors, text: "Professzionális megjelenés a bizalomépítés érdekében." },
    ],
  },
  whyTheyLove: {
    title: "Hogyan könnyíti meg a munkád a Wobble?",
    imageSrc: "../assets/mockup_dog_grooming.png",
    imageAlt: "Kutyakozmetikus időpontfoglalás",
    features: [
      { icon: GiDodge, text: "Gyorsan testreszabható foglalási rendszer" },
      { icon: GiScissors, text: "Egyedi szolgáltatások a különböző kutyafajták kezelésére" },
      { icon: GiStopwatch, text: "Automatikus emlékeztetők és visszaigazolások" },
      { icon: GiChatBubble, text: "Könnyű kommunikáció a gazdikkal egy helyen" },
      { icon: GiDodge, text: "Egyszerű időpontkezelés és átlátható naptár" },
    ],
  },
  trial: {
    title: "🐾 Csatlakozz most",
    title2: "30 nap ingyenes próbaidőszak!",
    subtitle:
      "Próbáld ki a Wobble-t kockázat nélkül, bankkártya megadása nélkül!",
    cta: {
      href: "https://app.wobble.hu/signup_page",
      label: "Regisztrálok most",
    },
  },
};
